import {
  UnclaimedMoneyHeader,
  SearchUnclaimedMoneyForm,
  UnclaimedMoneyHowItWorks,
  HelpfulTips,
  Faq,
  Text,
} from '@ltvco/refresh-lib';
import {
  unclaimedMoneyFaq,
  unclaimedMoneyHelpfulTips,
} from './unclaimedMoneyConstants';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

function useQueryParams(params: string) {
  return useMemo(() => new URLSearchParams(params), [params]);
}

export function UnclaimedMoney() {
  const { search } = useLocation();
  const queryParams = useQueryParams(search);
  const fname = queryParams.get('fname') || '';
  const lname = queryParams.get('lname') || '';
  const state = queryParams.get('state') || '';

  useEffect(() => {
    document.title = 'Unclaimed Money - NumberGuru';
  }, []);

  return (
    <>
      <UnclaimedMoneyHeader />
      <SearchUnclaimedMoneyForm fname={fname} lname={lname} state={state} />
      <Text marginBottom={2}>
        <strong>State availability:</strong> Unclaimed money search results are
        currently unavailable for the following states: AZ, CA, FL, GA, IL, KY,
        MA, MN, MO, NY, NV, OH, OK, PA, TN, VA. Updated 3/19/2024.
      </Text>
      <HelpfulTips tips={unclaimedMoneyHelpfulTips} />
      <UnclaimedMoneyHowItWorks />
      <Faq faqItems={unclaimedMoneyFaq} />
    </>
  );
}
